import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 6a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3z","key":"svg-0"}]]

const IconCrop32Filled = createReactComponent('filled', 'crop-3-2-filled', 'Crop32Filled', __iconNode);

export default IconCrop32Filled;